import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";

interface DeleteMerchantBankDto {
  merchantId: number;
  bankOrder: number;
}

export const useDeleteMerchantOneBank = () => {
  return useMutation(async (dto: DeleteMerchantBankDto) => {
    const response = await axiosInstance.post("/MerchantBank/DeleteMerchantBank", dto);
    return response.data;
  });
};
